import React from 'react';

interface ImageConfig {
  sizes: Record<string, string>,
  type: string,
}

interface IProps {
  alt: string;
  className?: string;
  filename: string;
  folder?: string;
  imageConfig?: Record<string, ImageConfig>;
  lazy?: boolean;
}

function Image({
  alt,
  className,
  filename,
  folder = filename,
  imageConfig,
  lazy = true
}: IProps): JSX.Element {
  return (
    <picture className={className}>
      <source srcSet={require(`../../assets/images/${folder}/${filename}.webp`).default} type='image/webp' />
      {
        imageConfig && Object.entries(imageConfig).map(([breakpoint, {sizes, type}], index) => (
          <source
            key={index}
            srcSet={
              Object.entries(sizes).map(([density, suffix]) => (
                `${require(`../../assets/images/${folder}/${filename}-${suffix}.jpg`).default} ${density}`
              )).join(', ')
            }
            media={breakpoint}
            type={`image/${type}`}
          />
        ))
      }
      <img
        src={require(`../../assets/images/${folder}/${filename}.jpg`).default}
        alt={alt}
        loading={lazy ? 'lazy': 'eager'}
      />
    </picture>
  );
}


export default React.memo(Image);